export const TOGGLE_SIDEBAR_STATE = "TOGGLE_SIDEBAR_STATE";
